import React, { Component } from "react";
import SideNavbar from "../components/navbars/SideNavbar";
import NavbarOne from "../components/navbars/NavbarOne";
import PreloaderTwo from '../components/preloader/PreloaderTwo';
import PageCardShimmer from '../components/preloader/PageCardShimmer';
import ManageQuestionPaperSection from "../components/questioners/manage_questin_papers/ManageQuestionPaperSection";
import Footer from "../components/footer/Footer";
import * as Cookies from "es-cookie";
import { getAuthorizedBranchIds } from "../../utils/branchScope";
import { canDelete } from "../../utils/modulePermissions";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import moment from 'moment';

import * as compose from 'lodash.flowright'; 
import { withRouter } from "react-router-dom";
import { Container } from "react-bootstrap";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile
} from "react-device-detect";

// Match on module_key only — "Online Exams" is the shared sidebar group, so matching
// it would let a sibling module's grant leak in. See ManageQuestionPaperSection.
const MANAGE_EXAMS_MODULE = ["Manage_Exams"];

const FETCH_EXAMS = gql`
  query($institution_id: Int!, $exam_paper_id: Int, $page: Int, $limit: Int, $branch_id: String) {
    manageQuestions(institution_id: $institution_id, exam_paper_id: $exam_paper_id, page: $page, limit: $limit, branch_id: $branch_id) {
      totalCount
      papers {
        id
        exam_mode
        name
        exam_type
        no_of_sets
        start_time
        end_time
        is_completed
        filename
        exam_name
        class
        class_id
        sub_exam_type
        section
        branch
      }
    }
  }
`;
const FETCH_EXAMS_COUNTS = gql`
query($institution_id: Int!, $branch_id: String) {
globals(institution_id: $institution_id, branch_id: $branch_id){
    manageQuestionData{
        total
        ongoing
        completed
        future
    }
    b_e_c_s_data {
        section_id
        class_id
        branch_id
        exam_id
      }
      educationalClasses {
        id
        class
      }
      exams {
        id
        exam
      }
      globalBranches {
        id
        branch_name
      }
      globalSections {
        id
        section_name
      }
    }
}
`;

const DELETE_EXAM = gql`
  mutation(
    $exam_paper_id: ID
    ) {
        deleteExamPaper(
            exam_paper_id: $exam_paper_id
    )
  }
`;


const FETCH_ADAPTIVE_EXAMS = gql`
  query($institution_id:Int!){
                        getAdaptiveExamGroups(institution_id:$institution_id){
                            group_exam_id
                            exam_name
                                schedule_sub_type_id
    schedule_sub_type_name
                        }
                    }  
`;


const FETCH_ADAPTIVE_EXAMSCHEDULESUBTYPES = gql` 
query($institution_id: Int!,$type: String) {
    getExamScheduleSubTypeQuestions(institution_id: $institution_id,type: $type){
        schedule_type_id
        schedule_sub_type_id
        schedule_sub_type
        adaptive_type_id
    }
}

`;

class ManageQuestionPaper extends Component {
  constructor(props) {
    super(props)
    this.state = {
      status: 1,
      page: 1,
      limit: 10,
      isPageLoading: false
    }
  }
  menuToggler = () => {
    const toggled = Cookies.get("toggle");
    if (toggled === "wrapper") {
      this.setState({ toggled: "wrapper sidebar-enable" });
      Cookies.set("toggle", "wrapper sidebar-enable");
    } else {
      this.setState({ toggled: "wrapper" });
      Cookies.set("toggle", "wrapper");
    }
  };
  handleDelete = async (e, cell, row, rowIndex, formatExtraData) => {
    // Backstop: ManageQuestionPaperSection already intercepts the trash click and
    // shows Access Denied, but this is where the mutation actually fires, so it
    // re-checks the grant rather than trusting the caller.
    if (!canDelete(MANAGE_EXAMS_MODULE)) return;

    const examName = rowIndex.exam_name || rowIndex.name || "this exam paper";
    if (!window.confirm(`Are you sure you want to delete "${examName}"? This action cannot be undone.`)) {
      return;
    }
    await this.props.handleDelete({
      variables: {
        exam_paper_id: rowIndex.id
      },
      update: (store, { data }) => {
        const data1 = store.readQuery({
          query: FETCH_EXAMS,
          variables: {
            institution_id: parseInt(Cookies.get("institutionid")),
            exam_paper_id: 0,
            page: this.state.page,
            limit: this.state.limit,
            branch_id: getAuthorizedBranchIds().join(",")
          }
        });

        const globals = store.readQuery({
          query: FETCH_EXAMS_COUNTS,
          variables: {
            institution_id: parseInt(Cookies.get("institutionid")),
            branch_id: getAuthorizedBranchIds().join(",")
          }
        });

        console.log("rowIndex", rowIndex);
        console.log("globals", globals, this.props);
        if (rowIndex.is_completed == "completed") {
          console.log("globals", globals, this.props);
          globals.globals.manageQuestionData.total = parseInt(globals.globals.manageQuestionData.total) - 1;
          globals.globals.manageQuestionData.completed = parseInt(globals.globals.manageQuestionData.completed) - 1;
        }
        else {
          globals.globals.manageQuestionData.total = parseInt(globals.globals.manageQuestionData.total) - 1;
          let now = moment().unix();
          if (now < rowIndex.start_time && rowIndex.is_completed == "Not completed") {
            globals.globals.manageQuestionData.future = parseInt(globals.globals.manageQuestionData.future) - 1;
          }
          else if (now > rowIndex.start_time && now <= rowIndex.end_time && rowIndex.is_completed == "Not completed") {
            globals.globals.manageQuestionData.ongoing = parseInt(globals.globals.manageQuestionData.ongoing) - 1;
          }

        }

        try {
          store.writeQuery({
            query: FETCH_EXAMS_COUNTS,
            variables: {
              institution_id: parseInt(Cookies.get("institutionid")),
              branch_id: getAuthorizedBranchIds().join(",")
            },
            data: globals
          });

        }
        catch (e) {
          console.log("Exception", e);
        }

        if (data1 && data1.manageQuestions) {
          data1.manageQuestions.papers = data1.manageQuestions.papers.filter(x => x.id != rowIndex.id);
          data1.manageQuestions.totalCount = data1.manageQuestions.totalCount - 1;
          try {
            store.writeQuery({
              query: FETCH_EXAMS,
              variables: {
                institution_id: parseInt(Cookies.get("institutionid")),
                exam_paper_id: 0,
                page: this.state.page,
                limit: this.state.limit,
                branch_id: getAuthorizedBranchIds().join(",")
              },
              data: data1
            });

          }
          catch (e) {
            console.log("Exception", e);
          }
        }

        if (data.deleteExamPaper) {
          this.setState({
            status: 2
          });
          setTimeout(() => { this.DeleteSetpageLoad() }, 1000);
        }
      }
    });
  }

  DeleteSetpageLoad = () => {
    console.log("setTimeout");
    this.setState({ status: 1 });
    window.location.reload(false);
  }

  handlePageChange = (page, sizePerPage) => {
    console.log("Pagination Change - Page:", page, "Size:", sizePerPage);
    this.setState({ page, limit: sizePerPage, isPageLoading: true });
    this.props.getExams.refetch({
      page: page,
      limit: sizePerPage
    }).then(() => {
      console.log("Refetch Success");
      this.setState({ isPageLoading: false });
    }).catch((e) => {
      console.log("Refetch Error:", e);
      this.setState({ isPageLoading: false });
    });
  }

  // handleEditFunction = (e, cell, row, rowIndex, formatExtraData) => {
  //   console.log("columnid", rowIndex);

  //   this.props.history.push("/questions/manage-question-paper/question-paper-result",
  //     {
  //       exam_id: rowIndex.id,
  //       exam_name: rowIndex.exam_name,
  //       exam_type: rowIndex.exam_type,
  //       class: rowIndex.class,
  //       class_id: rowIndex.class_id,
  //       sub_exam_type: rowIndex.sub_exam_type,
  //       is_completed: rowIndex.is_completed,
  //       start_time: rowIndex.conducted_on,
  //       filename: rowIndex.filename,
  //       student_results: rowIndex.student_results,
  //       result_graph: rowIndex.result_graph,
  //       start_timestamp: rowIndex.start_time,
  //       //exam_questions: rowIndex.exam_questions,
  //       branch: rowIndex.branch,
  //       section: rowIndex.section
  //     });
  // }
  render() {
    if (Cookies.get("token") == undefined) this.props.history.push("/login");
    const globals = this.props.globals;
    const loading1 = globals.loading;
    const error1 = globals.error;

    const getExams = this.props.getExams;
    const loading2 = getExams.loading;
    const error2 = getExams.error;

    const adaptiveExams = this.props.getAdaptiveExamGroups || [];
    const loading3 = adaptiveExams.loading;
    const error3 = adaptiveExams.error;

    const adaptiveExamsData = this.props.getAdaptiveExamGroups?.getAdaptiveExamGroups || [];

    const uniqueExams = adaptiveExamsData.filter((item, index, self) =>
      index === self.findIndex((u) => u.group_exam_id === item.group_exam_id)
    );


    const getExamScheduleSubTypeQuestions = this.props.getExamScheduleSubTypeQuestions;
    const loading4 = getExamScheduleSubTypeQuestions.loading;
    const error4 = getExamScheduleSubTypeQuestions.error;

    if (error1 !== undefined) {
      alert("Server Error. " + error1.message);
      return null;
    }

    if (error2 !== undefined) {
      alert("Server Error. " + error2.message);
      return null;
    }

    if (error3 !== undefined) {
      alert("Server Error. " + error2.message);
      return null;
    }

    if (error4 !== undefined) {
      alert("Server Error. " + error2.message);
      return null;
    }

    const manageQuestionsData = getExams.manageQuestions || {};
    const papers = manageQuestionsData.papers || [];
    const totalCount = manageQuestionsData.totalCount || 0;

    // Include exam_mode 0, 1 and 2 (not just online/0).
    const manageOnlineQuestions = papers.filter((item) => [0, 1, 2].includes(item.exam_mode));

    return (
      <div className={Cookies.get("toggle")}>
        <div className="header-area">
          <NavbarOne onClick={() => this.menuToggler()} />
        </div>
        <div className="main-wrapper">

          <div id="sidebar" className={isBrowser == true ? "sidebar-menu d-none d-xl-block d-lg-block" : "sidebar-menu d-block d-xl-none d-lg-none"}>
            <SideNavbar onClick={() => this.menuToggler()} />
          </div>
          {(loading1 === true || loading2 === true || loading3 === true || loading4 === true) && !this.state.isPageLoading && (<PageCardShimmer filters={4} cols={8} />)}
          <div className="student-overlay" onClick={() => this.menuToggler()} />
          <div className="content-wrapper pt-0 h-100">
            {
              !loading1 && (getExams.manageQuestions || !loading2) && (
                <div className="main-content">
                  <Container fluid>
                    <ManageQuestionPaperSection
                      stateData={this.state}
                      manageQuestions={manageOnlineQuestions}
                      totalCount={totalCount}
                      page={this.state.page}
                      limit={this.state.limit}
                      isPageLoading={this.state.isPageLoading}
                      onPageChange={this.handlePageChange}
                      globals={globals.globals}
                      getAdaptiveExamGroups={uniqueExams || []}
                      getExamScheduleSubTypeQuestions={getExamScheduleSubTypeQuestions.getExamScheduleSubTypeQuestions}
                      handleDelete={this.handleDelete} />
                  </Container>
                </div>)}

          </div>
          <Footer />
        </div>
      </div>

    );
  }
}


export default withRouter(compose(
  graphql(FETCH_EXAMS_COUNTS,
    {
      options: props => ({
        variables: {
          institution_id: parseInt(Cookies.get("institutionid")),
          branch_id: getAuthorizedBranchIds().join(",")
        }
        ,
        fetchPolicy: 'network-only'
      }), name: "globals"
    }),

  graphql(FETCH_ADAPTIVE_EXAMS,
    {
      options: props => ({
        variables: {
          institution_id: parseInt(Cookies.get("institutionid"))
        }
        ,
        fetchPolicy: 'network-only'
      }), name: "getAdaptiveExamGroups"
    }),
  graphql(FETCH_EXAMS,
    {
      options: props => ({
        variables: {
          institution_id: parseInt(Cookies.get("institutionid")),
          exam_paper_id: 0,
          page: 1,
          limit: 10,
          branch_id: getAuthorizedBranchIds().join(",")   // user's branches; "" = all
        }
        ,
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true
      }), name: "getExams"
    }),
  graphql(FETCH_ADAPTIVE_EXAMSCHEDULESUBTYPES,
    {
      options: props => ({
        variables: {
          institution_id: parseInt(Cookies.get("institutionid")),
          type: "Adaptive_Exam"

        }
      }), name: "getExamScheduleSubTypeQuestions"
    }),
  graphql(DELETE_EXAM, {
    name: "handleDelete"
  }))(ManageQuestionPaper));